import React from "react";

export const aboutTitle = "About";
export const aboutDetails =
  "I am Marius Monkam, Freelance consulting for Spotahome. My goal is to help you find quickly a room or an apartment via Spotahome platform. I decided to create this tool because it was impossible for me to respond to the large amount of request coming to me. As this tool will help you to strategize your research and gain in time, It will also help me to be more productive.";
export const marDiscountCode = "FBMARIUS15";
export const marDiscountCodeMsg =
  "Use this coupon code to get 15% discount on your reservation fees, valid all Spotahome offers.";

export const EmbedIframe = (src, title) => {
  return <iframe src={src} title={title}></iframe>;
};

export const NoticeBySpotahome = () => {
  return (
    <>
      <h3>NOTICE by SPOTAHOME</h3>
      <p>
        Spotahome don’t arrange in-person viewings as their properties already
        have virtual viewings and video tours so you can check out thousands of
        properties remotely, saving you time and money! Due to COVID-19 however,
        some of the properties have not been checked, so you will find images
        but unfortunately no videos or floor plans. However they’re pleased to
        say that their guarantee covers all their properties so you can book
        with peace of mind. If however you would like to see the property before
        your check-in date then this is open to negotiation between you and the
        landlord. You can find more information here:
        <a href="https://www.spotahome.com/how-it-works">
          {" "}
          <span className="bg-dark text-white">how it works </span>
        </a>
      </p>
    </>
  );
};

export const MarCouponCode = () => {
  return (
    <div
      className="col-md-6 col-sm-6 text-center bg-info rounded d-none d-lg-block"
      style={{
        display: "flex",
        flexDirection: "column",
        minheight: "300px",
        width: "200px",
      }}
    >
      <h4 className="mt-3 text-white ">
        USE MARIUS DISCOUNT CODE ON SPOTAHOME WEBSITE
      </h4>
      <h1
        className="lead text-center bg-dark border border-warning b-5 m-5 p-2 shadow"
        style={{
          verticalAlign: "middle",
          textAlign: "center",
          alignContent: "center",
          fontSize: "50px",
          fontWeight: "bold",
        }}
      >
        {marDiscountCode}
      </h1>
      <p>
        <em>{marDiscountCodeMsg}</em>
      </p>
    </div>
  );
};
